import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PublicHome from "@/pages/PublicHome";
import ProductPage from "@/pages/ProductPage";
import BlogList from "@/pages/BlogList";
import BlogArticle from "@/pages/BlogArticle";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProductForm from "@/pages/AdminProductForm";
import AdminArticleForm from "@/pages/AdminArticleForm";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicHome />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:id" element={<BlogArticle />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/products/new" element={<AdminProductForm />} />
          <Route path="/admin/products/:id" element={<AdminProductForm />} />
          <Route path="/admin/blog/new" element={<AdminArticleForm />} />
          <Route path="/admin/blog/:id" element={<AdminArticleForm />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
